export default __webpack_public_path__ + "static/media/697.a8d67373.gif";